import axios from 'axios'
axios.defaults.withCredentials = true
axios.defaults.headers.common['Content-type'] = 'application/json'
const instance = axios.create({
  baseURL: '/'
})

export default instance